import React from 'react';

import { PeopleTeamsAnalyticsProvider } from '@atlassian/people-teams-ui/analytics';
import { DialogProvider } from '@atlassian/people-teams-ui/dialogs';
import { type SentryClient, useTeamsSentryClientSetup } from '@atlassian/teams-client/sentry';

import { useSetAppConfig } from '../app-config-context/hooks/use-set-teams-app-config';
import { AppConfigProvider } from '../app-config-context/provider';
import { type AppConfigProviderProps, type AppConfigStoreState } from '../app-config-context/types';
import { ProfileCardClientConfigProvider } from '../profile-client/provider';

const IS_LOCAL = process.env.NODE_ENV === 'development';

/**
 * This component is intended to wrap all exported components from @atlassian/teams
 * It handles configuration & setup of the underlying clients.
 */
export function TeamsWrapper({
	children,
	appConfig,
}: {
	children: React.ReactNode;
	appConfig: AppConfigStoreState & AppConfigProviderProps;
	/**
	 * @deprecated no longer needed, sentry client is async loaded by default
	 */
	sentryClient?: SentryClient;
}) {
	useTeamsSentryClientSetup(!IS_LOCAL, {
		env: appConfig.env,
		appName: appConfig.appName ? `${appConfig.appName}` : undefined,
	});

	useSetAppConfig(appConfig);

	return (
		<AppConfigProvider {...appConfig}>
			<ProfileCardClientConfigProvider {...appConfig}>
				<PeopleTeamsAnalyticsProvider>
					<DialogProvider>{children}</DialogProvider>
				</PeopleTeamsAnalyticsProvider>
			</ProfileCardClientConfigProvider>
		</AppConfigProvider>
	);
}
